import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 4.64851C1 3.73806 1.7754 3 2.73191 3H9.42553C9.63391 3 9.83151 3.0881 9.96491 3.24047L12.3289 5.9406H21.2681C22.2246 5.9406 23 6.67864 23 7.58911V19.3515C23 20.262 22.2246 21 21.2681 21H2.73191C1.77541 21 1 20.262 1 19.3515V4.64851ZM2.40424 11.6881V19.3515C2.40424 19.5238 2.55094 19.6634 2.73191 19.6634H21.2681C21.4491 19.6634 21.5958 19.5238 21.5958 19.3515V11.6881H2.40424ZM21.5958 10.3515H2.40424V4.64851C2.40424 4.47626 2.55094 4.33662 2.73191 4.33662H9.09667L11.4606 7.03675C11.594 7.18912 11.7916 7.27722 12 7.27722H21.2681C21.4491 7.27722 21.5958 7.41684 21.5958 7.58911V10.3515Z"
      fill="currentColor"
    />
  </svg>
);
